import { FunctionComponent } from "react"
import { ICars } from "@/types/contentful"

import SectionTitle from "../SectionTitle/SectionTitle"
import CarsPageItem from "../CarsPageItem/CarsPageItem"

import styles from "./styles.module.scss"

interface CarsPageProps {
  cars: ICars[]
  distance?: number
  hours?: string
}

const CarsPage: FunctionComponent<CarsPageProps> = ({
  cars,
  distance,
  hours,
}) => {
  return (
    <div className={styles.cars__container}>
      <SectionTitle className={styles.cars__container_header}>
        Our cars
      </SectionTitle>
      {cars.map((car, index) => (
        <CarsPageItem
          key={index}
          {...car.fields}
          distance={distance}
          hours={hours}
        />
      ))}
    </div>
  )
}

export default CarsPage
